import.meta.glob(['../images/**/*']);

import './vendor/bootstrap';

document.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');

  if (!header) {
    return;
  }

  header.classList.toggle('site-header--scrolled', window.scrollY > 0);
});

document.querySelectorAll('.nav-toggle').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const header = toggle.closest('.site-header');

    if (!header) {
      return;
    }

    const isOpen = header.classList.toggle('site-header--open');

    toggle.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) {
    return;
  }

  const quantityButton = event.target.closest(
    '.woocommerce-product__quantity-button',
  );

  if (!quantityButton) {
    return;
  }

  const quantityField = quantityButton.closest('.quantity');
  const quantityInput = quantityField?.querySelector('input.qty');

  if (!(quantityInput instanceof HTMLInputElement)) {
    return;
  }

  try {
    if (quantityButton.dataset.step === '1') {
      quantityInput.stepUp();
    } else {
      quantityInput.stepDown();
    }
  } catch {
    const current = Number.parseFloat(quantityInput.value || '0');
    const step = Number.parseFloat(quantityInput.step || '1') || 1;

    quantityInput.value = String(
      current + (quantityButton.dataset.step === '1' ? step : -step),
    );
  }

  quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
});

if (window.jQuery) {
  const $ = window.jQuery;

  $('form.variations_form.cart').each((_, form) => {
    const $form = $(form);
    const $price = $form.closest('.summary').find('p.price').first();
    const originalPrice = $price.html();

    if (!originalPrice) {
      return;
    }

    $form.on('show_variation', (event, variation) => {
      if (!variation || !variation.price_html) {
        return;
      }

      $price.html(variation.price_html);
    });

    $form.on('hide_variation', () => {
      $price.html(originalPrice);
    });
  });
}
